(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfPostRepeat', [
    '$document', '$timeout', function($document, $timeout) {
      return {
        restrict: 'A',
        link: function(scope, ele, attrs) {
          if (scope.$last) {
            return $timeout((function(_this) {
              return function() {
                return scope.$emit(scope[attrs.mfPostRepeat]);
              };
            })(this));
          }
        }
      };
    }
  ]);

}).call(this);
